import { render, staticRenderFns } from "./testRouter3.vue?vue&type=template&id=5d6e0cae&scoped=true"
import script from "./testRouter3.vue?vue&type=script&lang=js"
export * from "./testRouter3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6e0cae",
  null
  
)

export default component.exports